import type { CategoryTree } from '~~/types/category/CategoryTree';

function createTreeConfig<T extends Record<string, CategoryTree>>(x: T) {

  return x;

}

export const CATEGORY_TREE = createTreeConfig({
  DEFAULT: { key: 'all-categories', prefix: '', typesenseKey: 'categories' },
  INDUSTRY: { key: 'industry-categories', prefix: '', typesenseKey: 'industry-categories' },
  LONGTAIL: { key: 'longtail-categories', prefix: '', typesenseKey: 'longtail-categories' },
} as const);
